import { render, staticRenderFns } from "./itemSearch.vue?vue&type=template&id=2879512a&scoped=true&"
import script from "./itemSearch.vue?vue&type=script&lang=js&"
export * from "./itemSearch.vue?vue&type=script&lang=js&"
import style0 from "./itemSearch.vue?vue&type=style&index=0&id=2879512a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879512a",
  null
  
)

export default component.exports